import React, { useState } from 'react';
import { Image } from "@project-stories/elements/Image/Image";
import { Button } from '@src/stories/elements/Button/Button';

export default function Accordion({ settings, blocks }) {
  const layoutType = 'accordion';
  const [activeIndex, setActiveIndex] = useState(0);

  const onTitleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={`solution-${layoutType} flex flex-col gap-8`}>
      <div className="flex flex-col items-center gap-11 text-center">
        <div className="flex flex-col max-w-[630px]">
          {settings.section.tagline && (
            <div className={`${settings.section.tagline_style_mobile}`}>
              {settings.section.tagline}
            </div>
          )}
          {settings.section.title && (
            <div className={`mt-3 ${settings.section.title_font_type_mobile}`}>
              {settings.section.title}
            </div>
          )}
        </div>
        {settings.section.subtitle && (
          <div className={`max-w-[436px] ${settings.section.subtitle_style_mobile}`}>
            {settings.section.subtitle}
          </div>
        )}
      </div>

      {blocks.length > 0 && (
        <div className="solution-blocks">
          {blocks.map((block, index) => (
            <React.Fragment key={index}>
              {/* Accordion Header */}
              <div 
                className={`
                  flex justify-between items-center cursor-pointer p-5
                  ${activeIndex === index ? 'bg-[#272726] text-white' : 'bg-transparent border-b border-black'}`
                }
                onClick={() => onTitleClick(index)}
              >
                <div className="flex flex-col flex-1 lg:py-2">
                  <div className="h5">
                    {block.settings.title}
                  </div>
                </div>
                <div className={`inline-flex items-center justify-center w-10 h-11 
                  transition-transform duration-300 ${
                    activeIndex === index ? 'rotate-90' : 'rotate-0'
                  }`}
                >
                  <svg width="44" height="40" viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id={`mask0_telco_faq_${index}`} style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="44" height="40">
                      <rect x="44" y="3.8147e-06" width="40" height="44" transform="rotate(90 44 3.8147e-06)" fill="#D9D9D9"/>
                    </mask>
                    <g mask={`url(#mask0_telco_faq_${index})`}>
                      <path d="M24.2 20L15.7667 12.3333L18.3333 10L29.3333 20L18.3333 30L15.7667 27.6667L24.2 20Z" fill={activeIndex === index ? "white" : "black"}/>
                    </g>
                  </svg>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index ? "max-h-[2000px]" : "max-h-0"
                }`}
              >
                <div className="flex flex-col gap-6 p-8 border-b border-black">
                  {block.settings.title && (
                    <div className={`${block.settings.title_font_type_mobile}`}>
                      {block.settings.title}
                    </div>
                  )}

                  {block.settings.subtitle && (
                    <div className={`${block.settings.subtitle_font_style_mobile}`}>
                      {block.settings.subtitle}
                    </div>
                  )}

                  {(() => {
                    const blockServices = (settings.blocks_services || []).find((b: any) => b.id === block.id);
                    const serviceList = (blockServices?.services_list || [])
                      .map((s: string) => s.trim())
                      .filter(Boolean);
                    return serviceList.length > 0 ? (
                      <ul className="solution-block__services flex flex-col gap-6">
                        {serviceList.map((service: string, i: number) => (
                          <li key={i} className="flex items-start gap-3">
                            {block.settings.service_icon && (
                              <Image
                                imageUrl={block.settings.service_icon}
                                useSrcSet={false}
                                classes="w-6 h-6 flex-shrink-0"
                              />
                            )}
                            <span className={`${block.settings.service_font_style_mobile}`}>
                              {service}
                            </span>
                          </li>
                        ))}
                      </ul>
                    ) : null;
                  })()}

                  {block.settings.image_mobile && (
                    <Image
                      imageUrl={block.settings.image_mobile}
                      alt={block.settings.title}
                      classes={[
                        block.settings.width_mobile ? `w-[${block.settings.width_mobile}%]` : 'w-auto',
                        block.settings.max_width_mobile ? `max-w-[${block.settings.max_width_mobile}px]` : '',
                        block.settings.width_mobile || block.settings.max_width_mobile || block.settings.max_height_mobile ? 'mx-auto' : '',
                        'h-auto',
                        block.settings.max_height_mobile ? `max-h-[${block.settings.max_height_mobile}px]` : '',
                        (block.settings.width_mobile || block.settings.max_width_mobile) && block.settings.max_height_mobile ? 'object-cover' : '',
                        `rounded-[${block.settings.image_border_radius}px]`,
                        'bg-white/0',
                      ].filter(Boolean).join(' ')}
                    />
                  )}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
};